import React from "react";

import DesktopTourProgress from "./desktop-tourProgress";
import MobileTourProgress from "./mobile-tourProgress";

const TourProgress = props => {
  const { percent, stopIndex, isDesktop } = props;

  const visible = stopIndex >= 2;
  let label = "";
  if (stopIndex > 8) label = "Tour Complete";
  else label = "Tour Progress Indicator";
  const labelVisible = (stopIndex >= 2 && stopIndex < 2.5) || stopIndex === 10;

  return isDesktop ? (
    <DesktopTourProgress
      percent={percent}
      visible={visible}
      label={label}
      labelVisible={labelVisible}
    />
  ) : (
    <MobileTourProgress
      percent={percent}
      visible={visible}
      label={label}
      labelVisible={labelVisible}
    />
  );
};

export default TourProgress;
